<template>
    <div>
        <img class="radio-img" v-if="injectUserId() == row.id" src="@/assets/public/active-radio.png" alt="">
        <img  class="radio-img" v-else src="@/assets/public/default-radio.png" alt="">
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
    inject: {
		injectUserId: {
			default: () => '',
		},
	},
    mixins:[mixin],
    data(){
        return{
          
        }
    }
}
</script>
<style lang="less" scoped>
.radio-img{
    width: 14px;
    height: 14px;
}
</style>